<template>
  <div>
    <el-card>
      <all-log :dialogLog="dialogLog" />

      <div class="menu-box">
        <h2>服务地点管理</h2>
        <div class="box-bd">
          <!-- 头 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-button type="primary" @click="pAdd()">添加服务地点</el-button>
              <el-button type="warning" @click="dialogLog.state = true"
                >查看日志</el-button
              >
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-table
            v-loading="tableLoading"
            class="task-table"
            :data="tableData"
          >
            <el-table-column prop="name" label="地址名"> </el-table-column>
            <el-table-column prop="short_name" label="简称"> </el-table-column>

            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.status === 1">
                  启用
                </el-tag>
                <el-tag type="warning" v-if="scope.row.status === 0">
                  禁用
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column width="180" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :pager-count="15"
            @current-change="pageChange"
            @size-change="sizeChange"
            :page-sizes="[7, 15, 20]"
            layout="total, sizes, prev, pager, next"
            :page-size="this.query.limit"
            background
            :total="exp.total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 添加/删除对话框 -->
    <el-dialog
      v-dialogDrag
      :title="title"
      :visible.sync="dialogVisible"
      :before-close="formClose"
    >
      <el-form :rules="formRules" ref="formRef" :model="form">
        <el-form-item
          prop="area_id"
          label="省市区"
          :label-width="formLabelWidth"
        >
          <el-cascader
            style="width:100%"
            :options="provList"
            :props="optionProps"
            v-model="form.area_id"
            @change="handleChange"
            filterable
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item
          prop="address"
          label="详细地址"
          :label-width="formLabelWidth"
        >
          <el-input
            @change="handleChange"
            v-model="form.address"
            placeholder="请填写详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="short_address"
          label="简称"
          :label-width="formLabelWidth"
        >
          <el-input
            @change="handleChange"
            v-model="form.short_address"
            placeholder="请填写简称"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item
            v-if="addOrEdit === 2"
            prop="sort"
            label="排序"
            :label-width="formLabelWidth"
          >
            <el-input @change="handleChange" v-model="form.sort"></el-input>
          </el-form-item> -->

        <el-form-item
          v-if="addOrEdit === 2"
          prop="status"
          label="状态"
          :label-width="formLabelWidth"
        >
          <el-switch
            @change="handleChange"
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </el-form-item>
      </el-form>
      <!-- 功能栏 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAE()">取 消</el-button>
        <el-button type="primary" @click="confirmAE()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLocList,
  provinceList,
  addLoc,
  getInfo,
  editLoc,
  delLoc,
} from '@/api/edu/location.js'

export default {
  data() {
    return {
      dialogLog: {
        state: false,
      },
      isEdit: false,
      tableLoading: false,
      warningText: '',
      exp: {
        total: 0,
      },
      spcateList: [],
      serviceList: [],
      query: {
        page: 1,
        page_code: '',
        limit: 7,
      },
      optionProps: {
        checkStrictly: false,
        value: 'id',
        label: 'cname',
        children: 'sub',
      },
      dialogVisible: false,
      changeDialogVisible: false,
      formRules: {
        area_id: {
          required: true,
          message: '请选择省市区',
          trigger: 'blur',
        },
        // sort: { required: true, message: '请输入物料列表排序' },
        address: { required: true, message: '请输入详细地址', trigger: 'blur' },
        short_address: {
          required: true,
          message: '请输入简称',
          trigger: 'blur',
        },
      },
      title: '添加服务地点',
      addOrEdit: 1,
      formLabelWidth: '120px',
      optionsTask: [],
      optionPropsTask: {
        value: 'id',
        label: 'name',
        children: 'son',
        disabled: 'state',
      },
      form: {
        area_id: '',
        address: '',
        short_address: '',
      },
      tableData: [],
      provList: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getOptionList() {
      const { data: res } = await provinceList()
      console.log(res)
      if (res.code === 1) {
        this.provList = res.data
      } else {
        this.$message.error('获取省市区数据失败！')
      }
    },
    pageChange(val) {
      this.query.page = val
      this.getList()
    },
    sizeChange(val) {
      this.query.limit = val
      this.getList()
    },
    async getList() {
      this.tableLoading = true
      const { data: res } = await getLocList(this.query)
      console.log(res)
      if (res.code === 1) {
        this.tableData = res.data
        this.exp.total = res.exp.num
      } else {
        this.$message.error('获取数据失败！')
      }
      this.tableLoading = false
    },
    // 添加/编辑商品对话框关闭事件
    formClose() {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.cancelAE()
          // this.getDepartmentList()
          done()
        })
        .catch((_) => {})
    },
    handleChange() {
      this.isEdit = true
    },
    handleChangeClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.changeDialogVisible = false
          this.getList()
          done()
        })
        .catch((_) => {})
    },
    // 取消
    cancelAE() {
      this.title = '添加服务地址'
      this.addOrEdit = 1
      this.isEdit = false
      this.form = {
        area_id: '',
        address: '',
        short_address: '',
      }
      if (this.$refs.formRef) {
        setTimeout(() => {
          this.$refs.formRef.clearValidate()
        }, 30)
      }

      this.dialogVisible = false
    },

    // 新增打开
    pAdd(row) {
      console.log(row)
      this.getOptionList()
      this.dialogVisible = true
    },
    // 编辑打开
    async handleEdit(row) {
      this.dialogVisible = true
      this.title = '编辑服务地址'
      this.addOrEdit = 2
      const { data: res } = await getInfo({
        address_id: row.id,
      })
      console.log(res.data)
      this.getOptionList()
      this.form.address = res.data.name
      this.form.address_id = res.data.id
      this.form.status = res.data.status
      this.form.short_address = res.data.short_name
      this.form.area_id = [
        res.data.area_class1,
        res.data.area_class2,
        res.data.area_class3,
      ]
    },

    // 删除
    remove(row) {
      this.$confirm('确认删除？')
        .then(async (_) => {
          const { data: res } = await delLoc({
            address_id: row.id,
          })
          if (res.code === 1) {
            this.$message.success('删除成功！')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
          this.cancelAE()
          // this.getDepartmentList()
          done()
        })
        .catch((_) => {})
    },
    confirmAE(e) {
      console.log(e)
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          if (this.addOrEdit === 1) {
            // 添加
            let area_id = this.form.area_id[this.form.area_id.length - 1]
            const { data: res } = await addLoc({
              area_id,
              address: this.form.address,
              short_address: this.form.short_address,
            })
            if (res.code === 1) {
              this.$message.success('添加成功')
              this.getList()
              this.cancelAE()
            } else {
              this.$message.error(res.message)
            }
          } else {
            // 编辑

            if (this.isEdit === true) {
              let area_id = this.form.area_id[this.form.area_id.length - 1]
              const { data: res } = await editLoc({
                address_id: this.form.address_id,
                area_id,
                address: this.form.address,
                status: this.form.status,
                short_address: this.form.short_address,
              })
              if (res.code === 1) {
                this.$message.success('编辑成功')
                this.cancelAE()
                this.getList()
              } else {
                this.$message.error(res.message)
              }
            } else {
              this.$message.info('没有修改任何数据')
            }
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.content {
  display: flex;
  align-items: center;
}
.content .warning-icon {
  width: 44px;
  height: 32px;
  margin-right: 10px;
  background: url('../../../assets/exclamationmark.png') no-repeat;
}
</style>
